import React from 'react';
import { Flex, Icon, Text } from '@spothero/ui';
import IconStar from '@spothero/icons/star-filled';
import IconStarHalf from '@spothero/icons/star-half';
import IconStarEmpty from '@spothero/icons/star-empty';
export const StarRating = ({ rating, filledColor = 'black', emptyColor = 'black', width = 4, height = 4, showLabel = true, }) => {
    return (<Flex alignItems="center" gap={1}>
            {[1, 2, 3, 4, 5].map(star => {
            const diff = rating - (star - 1);
            const isFilled = diff >= 1;
            const isHalf = diff >= 0.5 && diff < 1;
            let IconComponent = IconStarEmpty;
            let color = emptyColor;
            if (isFilled) {
                IconComponent = IconStar;
                color = filledColor;
            }
            else if (isHalf) {
                IconComponent = IconStarHalf;
                color = filledColor;
            }
            return (<Icon key={star} as={IconComponent} width={width} height={height} color={color}/>);
        })}
            {showLabel && (<Text fontWeight="semibold" fontSize="lg" ml={1}>
                    {rating}/5
                </Text>)}
        </Flex>);
};
